import React, { useContext, useEffect, useState } from 'react'
import { Breadcrumb, Heading, ContentDropDown } from '../common/atoms'
import { UserAlert } from '../common/atoms/alerts'
import { Table } from '../common/molecules'
import { UploadCard } from '../common/organisms'
import employeeDataApi from '../../services/employee_data.api'
import handleAppError from '../handlers/handleAppError'
import { AppStateContext, AppDispatchContext } from '../../utils/contexts'
import { recentSearchSchema as tableschema } from '../../schemas/table'
import { DRAGGER_CONTENT, FAQS } from '../../constants/employeeData'
import {RECENT_UPLOADS_HEADERS as HEADERS} from '../../constants/tableHeaders'

const FamilyRegistrationPage = ({ history }) => {
  const {employee_data:state} = useContext(AppStateContext)
  const dispatch = useContext(AppDispatchContext)
  const [recentUploads, setRecentUploads] = useState([])
  const [viewMoreFlag, setViewMoreFlag] = useState(false)

  const uploadRequest = (info) => {
    dispatch({ type: 'employee_data', file: info.file })
    history.push('/employee-data/file-upload?of=family_addition')

  }

  const fetchRecentUploads = async () => {
    try {
      let result = await employeeDataApi.fetch_recent_uploads({type: 'FamilyMemberRegistration'})
      let data = result.data.customer_data_uploads
      setRecentUploads(data || [])
    } catch (err) {
      handleAppError(err)
    }
  }

  const viewRecentHandler = (id) => {
    history.push('/employee-data/view-result?of=family_addition', {id})
  }

  useEffect(() => {
    if (state.pathId !== '0125') dispatch({ type: 'employee_data', file: null, tabledata: null, pathId: '0125' })
    if (state.click_dragger) {
      setTimeout(() => {
        const dragger = document.getElementById('dragger')
        dragger.click()
        dispatch({ type: 'toggle dragger click' })
      }, 0)
    }
    if(state.tabledata) dispatch({ type: '', showFamilyIcon: true })
    fetchRecentUploads()
  }, [])

  return (
    <React.Fragment>
      <Breadcrumb
        list={[
          { text: 'Manage Employees', link: '/employee-registration' },
          { text: 'Family Members', link: '/family-registration' },
        ]}
        classes='mb-1'
      />
      <Heading mainHeading='Family registration' mainClasses='text-xl leading-5 text-gray-900 font-semibold'/>
      {state.tabledata && (
        <UserAlert
          icon='red'
          para='Your file has been processed. There are some validation error in the data.'
          btntext='View Error'
          btnHandler={() => history.push('/employee-data/view-errors?of=family_addition')}
          classes='border border-red-600 p-3 mt-8'
          paraClasses='text-gray-900'
        />
      )}
      <UploadCard CONTENT={DRAGGER_CONTENT['family_register']} uploadRequest={uploadRequest} classes='mt-8'  listHeading={["Download CSV File", "Download XLSX File"]} />  
      <p className='tracking-widest text-xs text-gray-500  font-semibold mb-3 mt-12'>RECENT ACTIVITY</p>
      <Table classes='rounded-lg' tableClasses='alternate_gray200_color'  loading={false} loaderHeight={300} headers={HEADERS} data={viewMoreFlag ? recentUploads:recentUploads.slice(0, 3)} tableschema={tableschema} handler={viewRecentHandler}/>
      {recentUploads.length > 3  && <span className='text-base font-semibold text-blue-500 mt-4 block cursor-pointer' onClick={() => setViewMoreFlag(flag => !flag)}>VIEW {viewMoreFlag ? 'LESS':'MORE'}</span>}
      <div className='flex mt-12'>
        <div className='w-1/2'>
          <h1 className='text-lg font-semibold text-gray-700'>Frequently asked questions</h1>
          <p className='mb-0 mt-2 text-gray-600'>Can’t find the answer you’re looking for?</p>
          <p className='mb-0 text-gray-600'>
            Reach out to our <span className='font-semibold text-blue-500'>customer success manager.</span>
          </p>
        </div>
        <div className='w-1/2'>
          {FAQS['add_family'].map((item, ind) => {
            return <ContentDropDown key={item.title} {...item} classes={ind === 0 ? '' : 'mt-6'} />
          })}
        </div>
      </div>
    </React.Fragment>
  )
}

export default React.memo(FamilyRegistrationPage)
